// extracted by mini-css-extract-plugin
module.exports = {"w2qox70":"w2qox70","vsmka31":"vsmka31"};